/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import React from 'react';
import { Outlet } from "react-router-dom";
import Sidebar from '../components/Sidebar';
import { ToastContainer } from 'react-toastify';
import { withParamsAndNavigate } from '../components/WithParamsAndNavigate';
import { PopModal } from '../components/PopModal';
import { Modal } from 'react-bootstrap';
import Icon from '../components/Icon';
import SandboxModal from '../components/SandboxModal';
import ChatBubble from '../components/chat/ChatBubble';
import BaseCom from '../components/BaseCom';
import { HTMLEditorModal } from '../components/HTMLEditorModal';
import { ImageGalleryOverlay } from '../components/ImageGalleryOverlay';
import AIPretty from '../components/AI';
import { ProcessingModal } from '../components/ProcessingModal';
import { PDFModal } from '../components/PDFModal';

class Portal extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            user: props.user
        }
        this.onSidebarToggle = this.onSidebarToggle.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user)
            this.setState({ user: this.props.user });
    }

    onSidebarToggle(on) {
        this.setState({ sidebarToggle: on });
    }

    render() {
        return (
            <>
                <SandboxModal />
                <ToastContainer position="top-center"
                    autoClose={2500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light" />
                <PopModal />
                <PDFModal />
                <ImageGalleryOverlay />
                <HTMLEditorModal />
                <AIPretty />
                <ProcessingModal />
                <Modal show={this.props.showConnError}>
                    <Modal.Header>
                        <Modal.Title><Icon icon="faTriangleExclamation" /> Connection Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Could not connect to the server. Will try to reconnect every 5 seconds, this window will automatically disappear once re-connected.</p>
                    </Modal.Body>
                </Modal>
                <main className={this.state.sidebarToggle ? 'main-nav-open' : 'main-nav-close'}>
                    <Sidebar user={this.state.user} navigate={this.props.navigate} onSidebarToggle={this.onSidebarToggle} />
                    <ChatBubble />
                    <div className="c-pagewrapper">
                        <Outlet />
                    </div>
                </main>
            </>
        );
    }
}

export default withParamsAndNavigate(Portal);
